<template>
    <modal ref="alert" type="alert">
        <div class="modal-dialog mb-alert mt-2" role="document">
            <div class="modal-content">
                <div v-bind:class="alertBgClass" class="modal-status"></div>
                <div class="modal-body text-center py-4">
                    <!-- <button type="button" class="btn-close" style="position: absolute; top: 8px; right: 8px;" data-bs-dismiss="modal" aria-label="Close"></button> -->
                    <i v-if="alertType=='success'" class="fa-solid fa-circle-check fa-beat text-success"></i>
                    <i v-else-if="alertType=='warning'" class="fa-solid fa-exclamation fa-beat text-warning"></i>
                    <i v-else-if="alertType=='danger'" class="fa-solid fa-circle-exclamation fa-beat text-danger"></i>
                    <i v-else class="fa-solid fa-info fa-beat text-info"></i>
                    <h3>{{ alertTitle }}</h3>
                    <div class="text-muted">{{ alertText }}</div>
                </div>
                <div class="modal-footer">
                    <div class="w-100">
                        <div class="row">
                            <div class="col"><a href="#" v-bind:class="alertCancelClass" class="btn w-100" data-bs-dismiss="modal" data-button="cancel" v-if="alertCancelButton">
                                {{ alertCancelButton }}
                            </a></div>
                            <div class="col"><a href="#" v-bind:class="alertConfirmClass" class="btn w-100" data-bs-dismiss="modal" @click.prevent="confirm" v-if="alertConfirmButton">
                                {{ alertConfirmButton }}
                            </a></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </modal>

</template>

<script>
import { mapState, mapWritableState } from 'pinia'
import { useAlert } from '../../stores/alert';

export default {
    props: {
        backdrop: {
            required: false,
            default: true
        },
        keyboard: {
            required: false,
            default: true
        },
        focus: {
            required: false,
            default: true
        },
        type: {
            required: false,
            default: 'success' // 'success', 'danger', 'warning', 'info'
        },
        title: {
            required: false,
            default: ''
        },
        text: {
            requred: false,
            default: ''
        },
        confirmButton: {
            requred: false,
            default: null
        },
        confirmClass: {
            requred: false,
            default: null
        },
        cancelButton: {
            requred: false,
            default: null
        },
        cancelClass: {
            requred: false,
            default: null
        },
    },

    data() {
        return {
            allowedTypes: ['success', 'warning', 'danger', 'info'],
        };
    },

    computed: {
        ...mapWritableState(useAlert, {
                dialogOpenStatus: 'openDialog',
                alertConfirm: 'confirm'
            }),

        ...mapState(useAlert, {
                alertType: 'type',
                alertTitle: 'title',
                alertText: 'text',
                alertConfirmButton: 'confirmButton',
                alertCancelButton: 'cancelButton',
                alertTimeout: 'timeout'
            }),


        alertConfirmClass() {
            const alertStore = useAlert();

            if (this.allowedTypes.includes(alertStore.confirmClass)) {
                return 'btn-' + alertStore.confirmClass;
            }

            if (this.allowedTypes.includes(this.alertType)) {
                return 'btn-' + this.alertType;
            }

            return 'btn-info';
        },

        alertCancelClass() {
            const alertStore = useAlert();

            if (alertStore.allowedTypes.includes(alertStore.cancelClass)) {
                return 'btn-' + alertStore.cancelClass;
            }

            return 'btn-white';
        },

        alertBgClass() {
            if (this.allowedTypes.includes(this.alertType)) {
                return 'bg-' + this.alertType;
            }

            return 'bg-info';
        },
    },

    watch: {
        dialogOpenStatus(value) {
            if (value) {
                this.show();
            }
        }
    },

    methods: {
        show() {
            let modal = this.$refs['alert'];

            modal.modal.show();

            if (this.alertTimeout !== null && typeof this.alertTimeout == 'number') {
                setTimeout(function() {
                    modal.modal.hide();
                }, this.alertTimeout);
            }
        },

        confirm() {
            this.alertConfirm = true;
        },

        cancel() {
            this.alertConfirm = false;
        },
    },
}
</script>